import { Typography } from '@mui/material';
import { useParams, useSearchParams } from 'react-router-dom';
import VizzleMainContainer from '../vizzle/VizzleMainContainer';
import TeacherTopAppbar from '../appbar/TeacherTopAppbar';
import TeacherCourseMainTab from './components/TeacherCourseMainTab';
import { initDomains } from './context/TeacherCourseContextProvider';
import './TeacherCourse.scss';
import BackToPreviousLink from '../../components/navigator/back/BackToPreviousLink';
import TeacherCourseSearchBar from './components/TeacherCourseSearchBar';
// import { subjectList } from './components/TeacherCourseMenu';
import { FULL_SORTED_SUBJECT_CONSTANTS } from '../../constants/LessonConstant';

const TeacherCourses = () => {
  initDomains();
  const { subjectId } = useParams();
  const currentSelectSubject = [...FULL_SORTED_SUBJECT_CONSTANTS].find((s) => s.subjectId === Number(subjectId));
  const [searchParams] = useSearchParams();
  const backParam = searchParams.get('back');

  return (
    <VizzleMainContainer className='main-with-background-container flex-box'>
      <div className='my-courses'>
        <TeacherTopAppbar />
        <Typography variant='h6' className='subject-title'>
          {currentSelectSubject.name}
        </Typography>
        <div className='content'>
          <div className='search-panel'>
            <div className='back-to-previous-container'>
              {Boolean(backParam) && (
                <BackToPreviousLink />
              )}
            </div>
            <TeacherCourseSearchBar />
          </div>
          <TeacherCourseMainTab />
        </div>
      </div>
    </VizzleMainContainer>
  );
};

export default TeacherCourses;
